<template>
  <div class="botmbgd">
    用户：{{name}}
    <button class="login-out" @click="loginOut">退出账号</button>
  </div>
</template>

<script>
import Axios from "@/Axios";
import infoAction from "@/utils";
export default {
  name: "Cardinfo",
  data() {
    return {
      name: infoAction.getinfo("admin_info"),
    };
  },
  mounted() {},
  methods: {
    loginOut() {
      this.$emit('loginOut')
    }
  },
};
</script>
<style scoped>
.botmbgd {
  width: 100%;
  display: flex;
  padding: 10px 10px;
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0px 4px 24px 0px rgb(45 44 44 / 17%);
}
.login-out {
  margin-left: 20px;
  border: none;
  outline: none;
  background: #0D88FA;
  border: 1px solid #ffffff;
  color: #ffffff;
  border-radius: 20px;
  padding: 0px 10px;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/Cardinfo/Cardinfo.vue